import { useEffect, useState, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import CONFIG from "../../../utils/config";
import {
  getAnyTotalReport,
  getOnboardingCompletionReport,
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
  getCoeRea,
  getCoeReaResClear,
  getCoeOffices,
  getCoeOfficesResClear,
  getCoeManagers,
  getCoeManagersResClear,
  getCoeTrendCurve,
  getCoeTrendCurveResClear,
  getSavedFilterDataResponseClearById,
  getSavedFilterDataById,
} from "../../../redux/reports/actions";
import _ from "lodash";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableOnboard from "../ReportsComponents/ReportTableOnboard";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ManagerReportSecCoe from "../ReportsComponents/ManagerReportSecCoe";
import OfficeSectionCoe from "../ReportsComponents/OfficeSectionCoe";
import Loader from "../../../components/Loader/Loader";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ReportTableCoe from "../ReportsComponents/ReportTableCoe";
import AlertModalReports from "../ReportsComponents/alertModalReports";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import DonutTrendChartComponent from "../layout/DonutTrendChartComponent";
import moment from "moment";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import { isAndroid, isIOS } from "react-device-detect";
import ConfirmModal from "../../modal/ConfirmModal";

const CodeOfEthicsReportHomeSection = (props) => {
  const { isMobile } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");

  const authBroker = useSelector(state => state.auth.authBroker)
  const authIframeBroker = useSelector(state => state.auth.authIframeBroker)

  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
    };
  }, [filterId]);

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      })
    );
  };

  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById
  );

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0]
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    if (savedFiltersDataById?.filter_content) {
      const rea_ids = [];
      const manager_ids = [];
      const office_ids = [];
      const courseList = [];
      const providerList = [];

      savedFiltersDataById?.filter_content.selectedOfficeList.forEach(function (
        obj
      ) {
        office_ids.push(obj.office_id);
      });
      savedFiltersDataById?.filter_content.selectedTeamMatesList.forEach(
        function (obj) {
          rea_ids.push(obj.user_id);
        }
      );
      savedFiltersDataById?.filter_content.selectedManagerCoachList.forEach(
        function (obj) {
          manager_ids.push(obj.id);
        }
      );
      savedFiltersDataById?.filter_content.selectedProviderList.forEach(
        function (obj) {
          providerList.push(obj.p_id);
        }
      );
      savedFiltersDataById?.filter_content.selectedCourseList.forEach(function (
        obj
      ) {
        if (obj.source === "xsel") {
          courseList.push(obj.course_code);
        } else {
          courseList.push(obj.course_id);
        }
      });

      let userStatus = 4;
      if (_.isArray(savedFiltersDataById.filter_content.selectedAgentStatus)) {
        if (savedFiltersDataById.filter_content.selectedAgentStatus.includes(3) ||
          (savedFiltersDataById.filter_content.selectedAgentStatus.includes(1) && savedFiltersDataById.filter_content.selectedAgentStatus.includes(2))
        ) {
          userStatus = 3
        } else if (savedFiltersDataById.filter_content.selectedAgentStatus.includes(1)) {
          userStatus = 1
        } else if (savedFiltersDataById.filter_content.selectedAgentStatus.includes(2)) {
          userStatus = 2
        }
      }

      dispatch(
        getCoeRea({
          module: "getCoeReportRea",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: rea_ids,
            office_ids: office_ids,
            manager_uids: manager_ids,
            stat: savedFiltersDataById?.filter_content.selectedStatus,
            limit: 1,
            role: savedFiltersDataById?.filter_content.selectedRole,
            user_status: userStatus
          },
        })
      );

      // dispatch(
      //   getCoeTrendCurve({
      //     module: "getCoeReporTrend",
      //     postData: {
      //       token: isMobile
      //         ? localStorage.getItem(SessionKeys.API_TOKEN)
      //         : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //       rea_ids: rea_ids,
      //       office_ids: office_ids,
      //       manager_ids: manager_ids,
      //       stat: savedFiltersDataById?.filter_content.selectedStatus,
      //       year: _.toNumber(trendYear),
      //       role: savedFiltersDataById?.filter_content.selectedRole,
      //     },
      //   })
      // );

      dispatch(
        getAnyTotalReport({
          module: "getCodeOfEthicsReport",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: rea_ids,
            stat: savedFiltersDataById?.filter_content.selectedStatus,
            office_ids: office_ids,
            manager_uids: manager_ids,
            role: savedFiltersDataById?.filter_content.selectedRole,
            user_status: userStatus
          },
        })
      );

      dispatch(
        getCoeOffices({
          module: "getCoeReportOffices",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            office_ids: office_ids,
            limit: 1,
            stat: savedFiltersDataById?.filter_content.selectedStatus,
            rea_ids: rea_ids,
            manager_ids: manager_ids,
            role: savedFiltersDataById?.filter_content.selectedRole,
            user_status: userStatus
          },
        })
      );

      dispatch(
        getCoeManagers({
          module: "getCoeReportManagers",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            limit: 1,
            office_ids: office_ids,
            stat: savedFiltersDataById?.filter_content?.selectedStatus,
            rea_ids: rea_ids,
            manager_ids: manager_ids,
            role: savedFiltersDataById?.filter_content.selectedRole,
            user_status: userStatus
          },
        })
      );
    }
  }, [savedFiltersDataById]);

  const fileName = "CodeOfEthicsReport";
  const [confirmModal, setConfirmModal] = useState(false)
  const [overCrsGraphData, setOverCrsGraphData] = useState([]);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [realEstateAgent, setRealEstateAgent] = useState([]);
  const [overAllOfficesData, setOverAllOfficesData] = useState([]);
  const [overAllManagersData, setOverAllManagersData] = useState([]);
  const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
  const [overAllLearningHours, setOverAllLearningHours] = useState([]);
  const [OverAllStatsData, setOverAllStatsData] = useState([]);
  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [limitData, setLimitData] = useState();
  const [imgLoader, setImgLoader] = useState(true);
  const [reaList, setReaList] = useState([]);
  const [ofcList, setOfcList] = useState([]);
  const [mgrList, setMgrList] = useState();
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const [loadSpining, setLoadSpining] = useState(true);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Progress" },
    // { id: 1, value: "Learning Points" },
    // { id: 3, value: "Learning Hours" },
  ];
  // console.log("Thhh", overAllDataRes?.payload?.payload?.stats);
  const [statusFilterData] = useState([
    "Completed",
    "In Progress",
    "NotStarted",
  ]);
  const [profileReports, setProfileReports] = useState([]);
  const [totalRea, setTotalRea] = useState(0);
  const [totalOfc, setTotalOfc] = useState(0);
  const [totalManagers, setTotalManagers] = useState(0);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);

  const profileReportRes = useSelector((state) => state.report?.profileReport);
  const d = new Date();
  let year = d.getFullYear();
  const [trendYear, setTrendYear] = useState(year);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport
  );
  const coeReaSectRes = useSelector((state) => state.report?.coeReportRea);

  const coeOfficesSectRes = useSelector(
    (state) => state.report?.coeReportOffices
  );
  const coeTrendCurveRes = useSelector((state) => state.report?.coeTrend);
  const coeManagerSectRes = useSelector(
    (state) => state.report?.coeReportManager
  );
  // const crsCompletionTrendRes = useSelector(
  //   (state) => state.report.complianceCompletionTrend
  // );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(1);
  const [officeCounter, setOfficeCounter] = useState(1);
  const [managerCounter, setManagerCounter] = useState(1);
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [totalCountRea, setTotalCountRea] = useState("");
  const [showModalMsg, setShowModalMsg] = useState(
    "Available Real Estate Agents limit reached!"
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isExpand, setIsExpand] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    check: false,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedStatus: ["completed", "in-progress", "overdue", "not-started"],
    selectedRole: ["realtor", "manager", "guest", "all"],
    selectedAgentStatus: [1],
    clickedApply: false,
  });
  const [showFilters, setShowFilters] = useState({
    reportingPeriod: false,
    provider: false,
    offices: true,
    reportingTo: true,
    learningContentType: false,
    learningContent: false,
    agents: true,
    status: true,
    role: true,
    agentStatus: true,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: false,
      rea: true,
    },
    assignmentFrom: false
  });
  const [reaIds, setReaIds] = useState([]);
  const [officeIds, setOfficeIds] = useState([]);
  const [managerIds, setManagerIds] = useState([]);
  const [statusAPI, setStatusAPI] = useState([
    "completed",
    "in-progress",
    "not-started",
  ]);

  const [loadSpinner, setLoadSpinner] = useState(true);
  const [officeLabel, setOfficeLabel] = useState('')

  useEffect(() => {
		if (!_.isEmpty(authBroker)) {
			if (!_.isEmpty(authBroker.payload?.user?.config) && authBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authBroker])

  useEffect(() => {
		if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
			if (!_.isEmpty(authIframeBroker.payload?.user?.config) && authIframeBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authIframeBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authIframeBroker])

  useEffect(() => {
    if (!filterId || selectedFilters?.clickedApply) {
      // loadAllApi();
    }
  }, [dispatch]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === 'success') {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: false,
              provider: false,
              offices: true,
              reportingTo: false,
              learningContentType: false,
              learningContent: false,
              agents: true,
              status: true,
              role: false,
              agentStatus: false,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: false,
                rea: true,
              },
            })
            // setIsExpand(true)
          }
        }
      }
    }
  }, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: false,
            provider: false,
            offices: true,
            reportingTo: false,
            learningContentType: false,
            learningContent: false,
            agents: true,
            status: true,
            role: false,
            agentStatus: false,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: false,
              rea: true,
            },
          })
          // setIsExpand(true)
        }
      }
    }
  }, [authIframeBroker])

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    console.log(selectedFilters);
  }, [selectedFilters]);
  useEffect(() => {
    console.log("GET OFFICE IDS - ", officeIds);
  }, [officeIds]);

  let PageSize = 20;

  useEffect(() => {
    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if ((authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) && false) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters.selectedOfficeList.length == 0) {
            // alert('office requried');
            setIsLoading(false);
            setConfirmModal(true)
          } else {
            setIsLoading(true)
            setCounter(1);
            setOfficeCounter(1);
            setManagerCounter(1);
            setOfficeIds(
              selectedFilters.selectedOfficeList.map((obj) => {
                console.log("GET OFFICE IDS get", obj);
                return obj.office_id;
              })
            );
      
            setReaIds(
              selectedFilters.selectedTeamMatesList.map((obj) => {
                return obj.user_id;
              })
            );
      
            setManagerIds(
              selectedFilters.selectedManagerCoachList.map((obj) => {
                return obj.id;
              })
            );
      
            setStatusAPI(selectedFilters.selectedStatus);
            loadAllApi()
          }
        } else {
          // alert('hi')
          setIsLoading(false)
          setOfficeCounter(1)
          setLoadSpinner(false)
          setLoadSpining(false)
          setLoadSpin(false)
          setManagerCounter(1)
          setCounter(1)
          setTotalOfc(0)
          setOfcList([])
          setTotalManagers(0)
          setMgrList([])
          setTotalRea(0)
          setReaList([])
          setProfileReports([])
        }
      } else if (!_.isEmpty(selectedFilters)) {
        setCounter(1);
        setOfficeCounter(1);
        setManagerCounter(1);
        setOfficeIds(
          selectedFilters.selectedOfficeList.map((obj) => {
            console.log("GET OFFICE IDS get", obj);
            return obj.office_id;
          })
        );
  
        setReaIds(
          selectedFilters.selectedTeamMatesList.map((obj) => {
            return obj.user_id;
          })
        );
  
        setManagerIds(
          selectedFilters.selectedManagerCoachList.map((obj) => {
            return obj.id;
          })
        );
  
        setStatusAPI(selectedFilters.selectedStatus);
  
        // selectedFilters.selectedCourseList.forEach(function (obj) {
        //   if (obj.source === "xsel") {
        //     courseList.push(obj.course_code)
        //   } else {
        //     courseList.push(obj.course_id)
        //   }
        // })
        // loadAllApi();
      }
    }
    
  }, [selectedFilters, authBroker]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply)
    &&
    (authBroker.payload?.user || authIframeBroker.payload?.user) &&
    !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true) {
      setIsLoading(true);
      loadAllApi();
    }
  }, [reaIds, officeIds, statusAPI]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply)
      &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true
    ) {
      getREADATA();
    }
  }, [counter]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply)
      &&
    (authBroker.payload?.user || authIframeBroker.payload?.user) &&
    !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true
    ) {
      getOfficeData();
    }
  }, [officeCounter]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply)
      &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true
    ) {
      getManagerData();
    }
  }, [managerCounter]);

  // useEffect(() => {
  //   if (!filterId || selectedFilters?.clickedApply) {
  //     getTrendData();
  //   }
  // }, [trendYear]);

  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }

  const currentTableData = useMemo(() => {
    if (profileReports !== null) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      setCanShow(true);
      return profileReports.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, profileReports]);

  // *******************************//
  useEffect(() => {
    if (!_.isEmpty(coeReaSectRes)) {
      setLoadSpin(false);
      setLimitStatus(coeReaSectRes?.status);
      if (coeReaSectRes?.status === "success") {
        let allData = coeReaSectRes?.payload?.payload?.real_estate_agents;
        setTotalRea(coeReaSectRes?.payload?.payload?.total_rea);
        let temparr = _.cloneDeep(reaList);
        if (counter === 1) {
          temparr = [];
        }
        setReaList([...temparr, ...allData]);
        getCoeReaResClear();
      }
    }
  }, [coeReaSectRes]);

  useEffect(() => {
    if (!_.isEmpty(coeOfficesSectRes)) {
      setLoadSpinner(false);
      if (coeOfficesSectRes?.status === "success") {
        let allData = coeOfficesSectRes?.payload?.payload?.offices;
        setTotalOfc(coeOfficesSectRes?.payload?.payload?.total_office);
        let temparr = _.cloneDeep(ofcList);
        if (officeCounter === 1) {
          temparr = [];
        }
        setOfcList([...temparr, ...allData]);
        dispatch(getCoeOfficesResClear());
      }
    }
  }, [coeOfficesSectRes]);

  useEffect(() => {
    if (!_.isEmpty(coeManagerSectRes)) {
      setLoadSpining(false);
      if (coeManagerSectRes?.status === "success") {
        let allData = coeManagerSectRes?.payload?.payload?.managers;
        setTotalManagers(coeManagerSectRes?.payload?.payload?.total_managers);
        let temparr = _.cloneDeep(mgrList);
        if (managerCounter === 1) {
          temparr = [];
        }
        setMgrList([...temparr, ...allData]);
        dispatch(getCoeManagersResClear());
      }
    }
  }, [coeManagerSectRes]);

  useEffect(() => {
    setCounter(1);
    setOfficeCounter(1);
    setManagerCounter(1);
    setReaList([]);
    setOfcList([]);
    setMgrList([]);
    return () => {
      dispatch(getCoeReaResClear());
      dispatch(getCoeManagersResClear());
      dispatch(getCoeOfficesResClear());
    };
  }, []);

  // useEffect(() => {
  //   if (!_.isEmpty(coeOfficesSectRes)) {
  //     if (coeOfficesSectRes?.status === "success") {
  //       let allData = coeOfficesSectRes?.payload?.payload?.offices;
  //       setOverAllOfficesData(allData);
  //     }
  //   }
  // }, [coeOfficesSectRes])
  useEffect(() => {
    // setCrsCompltTrendValues([])
    return () => {
      dispatch(getCoeTrendCurveResClear());
    };
  }, []);
  useEffect(() => {
    if (!_.isEmpty(coeTrendCurveRes)) {
      if (coeTrendCurveRes?.status === "success") {
        setImgLoader(false);
        let allData = [];
        allData = coeTrendCurveRes?.payload?.payload?.completion_trend;
        setCrsCompltTrendValues(Object.values(allData));
        setFilterYearData(coeTrendCurveRes?.payload?.payload?.year);
        dispatch(getCoeTrendCurveResClear());
      }
    }
  }, [coeTrendCurveRes]);

  useEffect(() => {
    if (!_.isEmpty(anyTotalReportRes)) {
      // console.log("REA onboard",realEstateAgent)
      setIsLoaded(false);
      // setImgLoader(false);
      let sortedData = [];
      let legends = [];
      let series = [];
      if (anyTotalReportRes?.status === "success") {
        setIsLoading(false);
        const reportData = anyTotalReportRes?.payload?.payload?.user_data;
        setProfileReports(reportData);
        setProfileReportsFilter(reportData);
        if (statusFilterData.includes("Completed")) {
          let completedCount = reportData?.filter(
            (data) => data.status === "Completed"
          ).length;
          series.push(
            reportData?.filter((data) => data.status === "Completed").length
          );
          legends.push(`Completed (${completedCount})`);
        }
        if (statusFilterData.includes("In Progress")) {
          let inprogressCount = reportData?.filter(
            (data) => data.status === "In Progress"
          ).length;
          series.push(
            reportData?.filter((data) => data.status === "In Progress").length
          );
          legends.push(`In Progress(${inprogressCount})`);
        }
        if (statusFilterData.includes("NotStarted")) {
          let notStartedCount = reportData?.filter(
            (data) => data.status === "NotStarted"
          ).length;
          series.push(
            reportData?.filter((data) => data.status === "NotStarted").length
          );
          legends.push(`Yet to start (${notStartedCount})`);
        }
        // if (statusFilterData.includes("OverDue")) {
        //   series.push(
        //     reportData.filter((data) => data.status === "OverDue").length
        //   );
        //   legends.push("Over Due");
        // }

        if (legends.length < 3) {
          legends.push("Others");
          // console.log("TOTALRECORD", totalRecord, series);
          series.push(totalRecord - _.sum(series));
        }
        // console.log("LEGENDS", legends);
        // console.log("SERIES", series);
        setLegends(legends);
        setSeries(series);
        setCurrentPage(1);
      } else {
        setProfileReports([]);
        setProfileReportsFilter([]);
        setCanShow(false);
        setIsLoading(false);
      }
      dispatch(getAnyTotalReportClear());
    }
  }, [anyTotalReportRes]);

  const loadAllApi = () => {
    let userStatus = 4;
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }

    getREADATA(userStatus);
    // getTrendData();
    getTableReport(userStatus);
    getOfficeData(userStatus);
    getManagerData(userStatus);
    setReaList([]);
    setOfcList([]);
    setMgrList([]);
    setTotalManagers(0);
    setTotalOfc(0);
    setTotalRea(0);
  };

  const getREADATA = (userStatus = 0) => {
    console.log("GET OFFICE IDS", officeIds);
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    // GET REA DATA FOR COE REPORT
    dispatch(
      getCoeRea({
        module: "getCoeReportRea",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: reaIds,
          office_ids: officeIds,
          manager_uids: managerIds,
          stat: statusAPI,
          limit: counter,
          role: selectedFilters.selectedRole,
          user_status: userStatus,
        },
      })
    );
    // setTotalRea(0)
    // setReaList([])
  };

  // const getTrendData = () => {
  //   // GET TREND DATA FOR COE REPORT
  //   dispatch(
  //     getCoeTrendCurve({
  //       module: "getCoeReporTrend",
  //       postData: {
  //         token: isMobile
  //           ? localStorage.getItem(SessionKeys.API_TOKEN)
  //           : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //         rea_ids: reaIds,
  //         office_ids: officeIds,
  //         manager_ids: managerIds,
  //         stat: statusAPI,
  //         year: _.toNumber(trendYear),
  //         role: selectedFilters.selectedRole,
  //       },
  //     })
  //   );
  // };

  const getTableReport = (userStatus = 0) => {
    // GET TABLE DATA FOR COE REPORT
    dispatch(
      getAnyTotalReport({
        module: "getCodeOfEthicsReport",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: reaIds,
          stat: statusAPI,
          office_ids: officeIds,
          manager_uids: managerIds,
          role: selectedFilters.selectedRole,
          user_status: userStatus,
        },
      })
    );
  };

  const getOfficeData = (userStatus = 0) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    // GET OFFICE DATA
    dispatch(
      getCoeOffices({
        module: "getCoeReportOffices",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: officeIds,
          limit: officeCounter,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
          role: selectedFilters.selectedRole,
          user_status: userStatus,
        },
      })
    );
  };

  const getManagerData = (userStatus = 0) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    // GET MANAGER DATA
    dispatch(
      getCoeManagers({
        module: "getCoeReportManagers",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: managerCounter,
          office_ids: officeIds,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
          role: selectedFilters.selectedRole,
          user_status: userStatus,
        },
      })
    );
  };

  const ExportToExcel = () => {
    const data = _.cloneDeep(profileReports);
    for (let item of data) {
      item.status =
        item?.status === "In Progress"
          ? "In Progress"
          : item?.status === "NotStarted"
            ? "Yet to start"
            : "Completed";
      item.progress =
        item?.progress !== undefined && item?.progress !== ""
          ? item?.progress + "%"
          : "-";
      item.completion_date =
        item?.completion_date !== undefined && item?.completion_date !== ""
          ? moment(
            StaticUtils.getDateFromTimeStamp(item?.completion_date),
            "MM/DD/YYYY"
          ).format("DD MMM, YYYY")
          : "-";
    }

    let tempArr = [];
    for (const item of data) {
      let obj = {
        username: item.username,
        role: item.role,
        email: item.email,
        user_status: item?.user_status ? "Active" : "In Active",
        office_name: item.office_name,
        manager: item?.manager,
        completion_date: item.completion_date,
        status: item.status,
        progress: item.progress,
      };
      tempArr.push(obj);
    }

    const newThing = [];
    tempArr.map((item) => {
      newThing.push(
        _.mapKeys(item, (value, key) => {
          switch (key) {
            case "username":
              return "Name";
            case "role":
              return "Role";
            case "email":
              return "Email";
            case "user_status":
              return "User Status";
            case "office_name":
              return officeLabel;
            case "manager":
              return "Manager";
            case "status":
              return "Status";
            case "progress":
              return "% Progress";
            case "completion_date":
              return "Date of Completion";
            default:
              return;
          }
        })
      );
    });

    for (let i = 0; i < newThing.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete newThing[i].undefined;
    }

    for (let i = 0; i < data.length; i++) {
      // arrayObj[i].stroke = arrayObj[i]['key1'];
      delete data[i]._id;
    }
    // console.log('data:', data)
    // exportFromJSON({ data, fileName, exportType })

    //For mobile
    let tempObj = {
      method: "CodeOfEthicsReport",
      report: newThing,
    };
    if (window.callbackHandler != undefined) {
      window.callbackHandler.postMessage(JSON.stringify(tempObj));
    } else if (window.webkit != undefined) {
      if (window.webkit.messageHandlers.callbackHandler != undefined) {
        window.webkit.messageHandlers.callbackHandler.postMessage(
          JSON.stringify(tempObj)
        );
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(newThing);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };

  const searchTable = (searchVal) => {
    let list = _.cloneDeep(profileReportsFilter);
    console.log(list, searchVal);
    if (searchVal === "") {
      setProfileReports(list);
      return;
    }

    let filterBySearch = [];

    for (const item of list) {
      let user_status = "";
      if (item?.user_status) {
        user_status = "active";
      } else {
        user_status = "in active";
      }
      if (
        item?.username?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.email?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.office_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        user_status?.toLowerCase().includes(searchVal.toLowerCase())
        // || item?.completion_date?.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);

    setProfileReports(filterBySearch);
  };

  // console.log("REA", reaList)
  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header pt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn"
                  onClick={() => {
                    let obj = { message: "backButton" };
                    dispatch(getSavedFilterDataResponseClearById());
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        CONFIG.API_URL_BROKER_ADMIN
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton"
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                    // dispatch(
                    //   getCrsReportReaClear(),
                    //   getCrsReportStatsClear(),
                    //   getCrsReportTrendClear()
                    // );
                  }}
                >
                  Back
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">Reports</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={"Code of Ethics Report"}
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  isMobile={isMobile}
                  showFilters={showFilters}
                  hideOverDueStatus={true}
                  reportType={"code_of_ethics"}
                />
              )}
            </div>
          </div>
        </div>
      </section>
      {/* <section className="onboarding-report">
        <div className="container">
          <div className="row">
            <div className="col-md-12 selctdrop-report">
              <div className="progess-report-title">Code Of Ethics Report</div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="progress-report-data">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-start mb-4">
                            <button
                                type="button"
                                id="backbtnreport"
                                className="btn btn-primary-complete bckbtn"
                                onClick={() => {
                                    navigate(-1)
                                    dispatch(getCoeReaResClear(),
                                        getCoeTrendCurveResClear()
                                    );
                                }}
                            >
                                Back
                            </button>
                        </div>
                        <div className="col-md-12 col-lg-6 mb-4">
                            <div className="graph-box-learnong">
                                <PieChartComponent
                                    type={type}
                                    isView={isView}
                                    legends={legends}
                                    series={series}
                                    setCanShow={setCanShow}
                                    statusFilterData={statusFilterData}
                                    totalRecord={totalRecord}
                                    currentTableData={currentTableData}
                                    isCoeReport={"coe"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
      {false && (
        <section className="progress-report-data">
          <div className="container">
            <DonutTrendChartComponent
              blockTitle={""}
              dropDownLabel={"Select Year"}
              dropDownArray={filterYearData}
              selectDropDown={setTrendYear}
              loader={imgLoader}
              setLoader={setImgLoader}
              donutTitle={"Completion Status"}
              series={series}
              legends={legends}
              selectedTitle={"2023"}
              trendTitle={"Code of Ethics Completion Trend"}
              trendValues={crsCompltTrendValues}
              useTrendValues={true}
              completionTrendYAxisLabel={"Agents Completed"}
            />
          </div>
        </section>
      )}
      <div id="myOnboard" class="center_line"></div>

      {/* <OfficeSectionCoe
        isMobile={isMobile}
        counter={officeCounter}
        setCounter={setOfficeCounter}
      /> */}

      <section className="offices-rpeort progress-box-report">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="progess-count-tiel">
              {officeLabel === "Office Name" ? "Offices" : officeLabel} &nbsp;<strong>({totalOfc})</strong>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            {!_.isEmpty(ofcList) ? (
              ofcList?.map((i, index) => {
                return (
                  <>
                    <div
                      className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report"
                      key={index}
                    >
                      <div className="reopor-box-progess">
                        <div className="progess-profile d-flex">
                          <div className="userprogress-details">
                            <h5 className="user-tiele">{i?.office_name}</h5>
                            <OverlayTrigger
                              key="bottom"
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-bottom`}>
                                  <div
                                    style={{
                                      color: "white",
                                      backgroundColor: "black",
                                    }}
                                  >
                                    {i?.office_address}
                                  </div>
                                </Tooltip>
                              }
                            >
                              <p>{i?.office_address}</p>
                            </OverlayTrigger>
                            {/* <p>{i?.office_address}</p> */}
                          </div>
                        </div>
                        <hr />
                        <div class="progress-details">
                          <div class="progess-report-graph">
                            <div class="circlebox">
                              <div
                                className="circularProgress-sm"
                                style={{
                                  width: 72,
                                  height: 72,
                                  position: "relative",
                                }}
                              >
                                <CircularProgressbar
                                  value={i?.percentage}
                                  strokeWidth={8}
                                  styles={buildStyles({
                                    pathColor: "#774D9F", //FF9700=yellow
                                    trailColor: "#EBEBEB",
                                  })}
                                />
                                <div
                                  className="centerprogess-con"
                                  style={{
                                    position: "absolute",
                                    top: "1.2rem",
                                    width: "72px",
                                    textAlign: "center",
                                  }}
                                >
                                  {true ? (
                                    <>
                                      <strong
                                        style={{ color: "#774D9F" }}
                                      >{`${i?.percentage}%`}</strong>
                                      <small>Progress</small>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="progess-count-show-new">
                            <div class="learning-points-new">
                              <strong>{i?.completed_user}/</strong>
                              {i?.total_checkList}
                            </div>
                            <div class="learning-points-name">Agents</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })
            ) : loadSpinner && officeCounter === 1 ? (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <Spinner animation="border" />
                </div>
              </div>
            ) : (
              <div className="col-md-12">
                <div className="not-found mt-3">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>
                      The {officeLabel === "Office Name" ? "Offices" : officeLabel} of Managers and REA's of above section will be
                      displayed in this section.
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-12 mt-3">
              <p className="text-center">
                {ofcList?.length === 0 ||
                  totalOfc === ofcList?.length ||
                  totalOfc < 4 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setOfficeCounter(officeCounter + 1);
                      setLoadSpinner(true);
                    }}
                  >
                    {loadSpinner ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                    ) : (
                      "Load More"
                    )}
                  </button>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <ManagerReportSecCoe
        isMobile={isMobile}
        counter={managerCounter}
        setCounter={setManagerCounter}
      /> */}

      <section className="manager-section-report progress-box-report">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="progess-count-tiel">
                Managers &nbsp;
                <strong>({totalManagers})</strong>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            {!_.isEmpty(mgrList) ? (
              mgrList?.map((m, index) => {
                return (
                  <div
                    className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report"
                    key={index}
                  >
                    <div className="reopor-box-progess">
                      <div className="progess-profile d-flex">
                        <div className="user-progess-img">
                          <img src={m?.profile_pic} width="48" height="48" />
                        </div>
                        <div className="userprogress-details">
                          <h5 className="user-tiele">{m?.user_name}</h5>
                          <OverlayTrigger
                            key="bottom"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-bottom`}>
                                <div
                                  style={{
                                    color: "white",
                                    backgroundColor: "black",
                                  }}
                                >
                                  {m?.office_name}
                                </div>
                              </Tooltip>
                            }
                          >
                            <p>{m?.office_name}</p>
                          </OverlayTrigger>
                          {/* <p>{m?.office_name}</p> */}
                        </div>
                      </div>
                      <hr />
                      <div class="progress-details">
                        <div class="progess-report-graph">
                          <div class="circlebox">
                            <div
                              className="circularProgress-sm"
                              style={{
                                width: 72,
                                height: 72,
                                position: "relative",
                              }}
                            >
                              <CircularProgressbar
                                value={m?.learning_percentage}
                                strokeWidth={8}
                                styles={buildStyles({
                                  pathColor: "#774D9F", //FF9700=yellow
                                  trailColor: "#EBEBEB",
                                })}
                              />
                              <div
                                className="centerprogess-con"
                                style={{
                                  position: "absolute",
                                  top: "1.2rem",
                                  width: "72px",
                                  textAlign: "center",
                                }}
                              >
                                {true ? (
                                  <>
                                    <strong
                                      style={{ color: "#774D9F" }}
                                    >{`${m?.learning_percentage}%`}</strong>
                                    <small>Progress</small>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="progess-count-show-new">
                          <div class="learning-points-new">
                            <strong>{m?.completed_checkList}/</strong>
                            {m?.total_checkList}
                          </div>
                          <div class="learning-points-name">
                            {/* Ethics consent */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : loadSpining && managerCounter === 1 ? (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <Spinner animation="border" />
                </div>
              </div>
            ) : (
              <div className="col-md-12">
                <div className="not-found mt-3">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>
                      This section will display the Managers that have to
                      complete the Code of Ethics.
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-12 mt-3">
              <p className="text-center">
                {mgrList?.length === 0 ||
                  totalManagers === mgrList?.length ? (
                  ""
                ) : totalManagers < 4 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setManagerCounter(managerCounter + 1);
                      setLoadSpining(true);
                    }}
                  >
                    {loadSpining ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                    ) : (
                      "Load More"
                    )}
                  </button>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="progress-box-report">
        <div className="container">
          <div className="row">
            <div className="col-md-12 flex-titlereport d-flex justify-content-between align-items-baseline">
              <div className="progess-count-tiel">
                Real Estate Agents&nbsp;
                <strong>({totalRea})</strong> - Cumulative Progress
                of an Agent
              </div>
            </div>
          </div>
          <div className="row mt-3">
            {!_.isEmpty(reaList) ? (
              reaList?.map((m, index) => {
                return (
                  <div
                    className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report"
                    key={index}
                  >
                    <div className="reopor-box-progess">
                      <div className="progess-profile d-flex">
                        <div className="user-progess-img">
                          <img src={m?.profile_pic} width="48" height="48" />
                        </div>
                        <div
                          className={`userprogress-details ${m?.is_allow === true && false
                              ? "cursor-pointer"
                              : "cursor-not-allowed"
                            }`}
                        >
                          <h5
                            className="user-tiele"
                            onClick={() => {
                              if (!isMobile && false) {
                                navigate(
                                  `/profile/edit?section=edit&user_id=${m?.uid}`
                                );
                              }
                            }}
                          >
                            {m?.user_name}
                          </h5>
                          <OverlayTrigger
                            key="bottom"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-bottom`}>
                                <div
                                  style={{
                                    color: "white",
                                    backgroundColor: "black",
                                  }}
                                >
                                  {m?.office_name}
                                </div>
                              </Tooltip>
                            }
                          >
                            <p>{m?.office_name}</p>
                          </OverlayTrigger>
                          {/* <p>{m?.office_name}</p> */}
                        </div>
                      </div>
                      <hr />
                      <div class="progress-details cod-progress">
                        <div class="progess-report-graph">
                          <div class="circlebox">
                            <div
                              className="circularProgress-sm"
                              style={{
                                width: 72,
                                height: 72,
                                position: "relative",
                              }}
                            >
                              <CircularProgressbar
                                value={m?.learning_percentage}
                                strokeWidth={8}
                                styles={buildStyles({
                                  pathColor: "#774D9F", //FF9700=yellow
                                  trailColor: "#EBEBEB",
                                })}
                              />
                              <div
                                className="centerprogess-con"
                                style={{
                                  position: "absolute",
                                  top: "1.2rem",
                                  width: "72px",
                                  textAlign: "center",
                                }}
                              >
                                {true ? (
                                  <>
                                    <strong
                                      style={{ color: "#774D9F" }}
                                    >{`${m?.learning_percentage}%`}</strong>
                                    <small>Progress</small>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="progess-count-show-new">
                          <div class="learning-points-new">
                            <strong>{m?.completed_checkList}/</strong>
                            {m?.total_checkList}
                          </div>
                          <div class="learning-points-name">
                            {/* Ethics consent */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : loadSpin && counter === 1 ? (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <Spinner animation="border" />
                </div>
              </div>
            ) : (
              <div className="col-md-12">
                <div className="not-found mt-3">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>
                      This section will display the REA's that have to complete
                      the Code of Ethics.
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-12 mt-3">
              {/* <p className="text-center">
                {(limitStatus === "error") ?
                  "" :
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "Load More"}
                  </button>
                }
              </p> */}
              <p className="text-center">
                {reaList?.length === 0 ||
                  totalRea === reaList?.length ? (
                  ""
                ) : totalRea < 4 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }}
                  >
                    {loadSpin ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                    ) : (
                      "Load More"
                    )}
                  </button>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* <RealEstateAgentsReportSection overAllData={overAllData} /> */}

      <div id="myOnboard" class="center_line"></div>
      <div className="coe-tablebox">
        <ReportTableCoe
          setSearchInput={""}
          getFilteredData={[]}
          lpName={"Onboarding Name"}
          isView={isView}
          statusFilterData={statusFilterData}
          setCanShow={setCanShow}
          profileReports={profileReports}
          currentTableData={currentTableData}
          type={type}
          message={
            "This section will display the Managers and REAs that have initiated / in progress / completed the Code of Ethics in tabular manner."
          }
          searchTable={searchTable}
          isMobile={isMobile}
          setIsLoading={setIsLoading}
        />
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={
          `${officeLabel == 'Office Name' ? 'Office(s)' : officeLabel} is mandatory, please select first.`
        }
        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};

export default CodeOfEthicsReportHomeSection;
